import { render, staticRenderFns } from "./packaging-data-card.vue?vue&type=template&id=9a930c4e&scoped=true"
import script from "./packaging-data-card.vue?vue&type=script&lang=js"
export * from "./packaging-data-card.vue?vue&type=script&lang=js"
import style0 from "./packaging-data-card.vue?vue&type=style&index=0&id=9a930c4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a930c4e",
  null
  
)

export default component.exports